<ng-container *ngIf="ticket">
  <app-link [link]="'general.api_general_back'" [icon]="'arrow_left'" (linkClicked)="toList()"></app-link>
  <br>
  <div class="flex flex-wrap flex-center space-between bottom-spacer-x2">
    <div class="flex flex-wrap flex-center">
      <h1 class="break-word no-margin">
        {{ ('general.api_ticket_tool_ticket_id' | translate) }} {{ ticket.id }}
      </h1>
      <span class="badge {{ currentOperation.status === 'REFUNDED' ? 'accent' : 'released' }}" *ngIf="currentOperation">
        {{ ('general.api_ticket_tool_status_' + (currentOperation.status | lowercase)) | translate }}
      </span>
    </div>
    <div class="flex flex-wrap" *ngIf="currentOperation">
      <app-link [icon]="'transaction'" [link]="'general.api_ticket_tool_last_transaction'"
                (linkClicked)="openTransaction(currentOperation.transaction.id)" [disabled]="authService.user.centreId !== currentOperation.salespoint.centreId"></app-link>
      <app-link [icon]="'qr_code'" [link]="'general.api_ticket_tool_qr_code'"
                (linkClicked)="showQR()" [disabled]="currentOperation.status !== TicketStatus.Sold"></app-link>
    </div>
  </div>
  <mat-card appearance="outlined">
    <h3 class="bold no-margin">{{ ticket.event.title | translateValue }}</h3>
    <app-event-info-props [eventProps]="{id: ticket.event.id, eventPeriod: ticket.event.eventDate, venueTitle: ticket.event.venueTitle, onlineLocation: ticket.event.onlineLocation}"></app-event-info-props>
    <br>
    <app-data-table *ngIf="dataTableConfig" [config]="dataTableConfig" [data]="ticket.operations" [useResponsive]="true"></app-data-table>
  </mat-card>
</ng-container>
<app-loader [loading]="isLoading" [overlay]="true"></app-loader>

<!-- TABLE TEMPLATES -->
<ng-template #statusTemplate let-item="item">
  {{ ('general.api_ticket_tool_status_' + (item.status | lowercase)) | translate }}
</ng-template>
<ng-template #opTimeTemplate let-item="item">
  {{ item.time | moment: { withTime: true } }}
</ng-template>
<ng-template #transactionIdTemplate let-item="item">
  <app-link *ngIf="item.transaction" [link]="item.transaction.id.toString()" (linkClicked)="openTransaction(item.transaction.id)"></app-link>
</ng-template>
<ng-template #invoiceNumberTemplate let-item="item">
  {{ item.transaction.invoiceNumber || '-' }}
</ng-template>
<ng-template #ticketTypeTemplate let-item="item">
  {{ item.pricing.typeName | translateValue }}
</ng-template>
<ng-template #priceTemplate let-item="item">
  {{ item.pricing.price | price: true }}
</ng-template>
<ng-template #feesTemplate let-item="item">
  <div class="flex flex-column decreased-margin align-right">
    <span *ngFor="let fee of item.pricing.fees">
      <span class="medium">{{ (fee.name || '-') | translateValue }}</span>
      <br>{{ fee.price | price: true }}
    </span>
    <span *ngIf="!item.pricing?.fees?.length">-</span>
  </div>
</ng-template>
<ng-template #totalTemplate let-item="item">
  {{ item.pricing.total | price: true }}
</ng-template>
<ng-template #customerTemplate let-item="item">
  <app-link *ngIf="canNavigateToCustomer(item.transaction?.customer?.uuid)" [link]="(item.transaction.customer.firstName || '-') + ' ' + (item.transaction.customer.lastName || '')"
            (linkClicked)="openCustomer(item.transaction.customer.uuid)"></app-link>
  <span class="medium" *ngIf="!canNavigateToCustomer(item.transaction?.customer?.uuid)">
    {{ (item.transaction.customer.firstName || '-') + ' ' + (item.transaction.customer.lastName || '') }}
  </span>
</ng-template>
<ng-template #deliveryEmailTemplate let-item="item">
  <br>{{ item.transaction?.customer?.deliveryEmail }}
</ng-template>
<ng-template #salespointTemplate let-item="item">
  <span class="medium">{{ item.salespoint?.name || '-' }}</span>
</ng-template>
<ng-template #sellerTemplate let-item="item">
  <br>{{ item.user?.firstName }} {{ item.user?.lastName }}
</ng-template>

<!-- QR Code modal -->
<ng-template #qrCodeDialogTemplate>
  <app-dialog-header [title]="'general.api_ticket_tool_qr_code'"></app-dialog-header>
  <mat-dialog-content>
    <app-loader class="top-spacer bottom-spacer" [loading]="isLoading" [size]="16"></app-loader>
    <div class="align-center">
      <qrcode [qrdata]="ticket.barcode" [width]="256" [errorCorrectionLevel]="'M'" [alt]="ticket.barcode"></qrcode>
    </div>
  </mat-dialog-content>
  <app-dialog-footer></app-dialog-footer>
</ng-template>
